import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

// ** Extend Core's Collapse molecule **
export const Collapse = ({
  buttonContent,
  children,
  isActive,
  onClick,
  index,
  ...otherProps
}) => {
  //const [isExpanded, setIsExpanded] = useState(isActive);
  const collapseRef = useRef(null);

  useEffect(() =>{
    if(typeof window.mzAnimator === 'object'){
       function setHeight(){
           window.mzAnimator.animateHeight(collapseRef.current, 'CollapseDealer' + index, 'init')
          // console.log('init',collapseRef.current, index, window.mzAnimator.heightOrigin['TrimCollapse' + index])
           if(window.mzAnimator.heightOrigin['CollapseDealer' + index] === 0){
               setTimeout(setHeight, 100);
           }
       }
       setHeight()
    }
  },[]);

  useEffect(() =>{
      window.mzAnimator.animateHeight(collapseRef.current, 'CollapseDealer' + index, isActive)
      //console.log('isExpanded',collapseRef.current, index, window.mzAnimator.heightOrigin['TrimCollapse' + index], isExpanded)
  },[isActive]);
  
  return (
    <div className={`${window.bnp_retailer_mode ? '' : 'mz-collapse mz-collapse-forms mzReactForms-component'}`}>
      <button
        onClick={() => {
          if (onClick) {
            onClick();
          }
          //setIsExpanded(!isExpanded);f
        }}
        className={`mz-collapse__button ${!isActive ? '' : 'active'}`}
        {...otherProps}
      >
        {buttonContent}
        {!window.bnp_retailer_mode && <i className={`mz-svg mz-svg-chevroncarousel mz-svg--grey${isActive ? 'visible' : ''}`}></i>}
      </button>
      <div className="mz-collapse__box visible" ref={collapseRef}>
        {children}
      </div>
    </div>
  )
}

Collapse.propTypes = {
  buttonContent: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired
  ]),
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
}

Collapse.defaultProps = {
  isActive: false,
  onClick: undefined
}

export default Collapse;